import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=0321138a&"
import script from "./Burger.vue?vue&type=script&lang=ts&"
export * from "./Burger.vue?vue&type=script&lang=ts&"
import style0 from "./Burger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports